module.exports = __webpack_public_path__ + "static/media/Zeigarnik Effect - david-clode-haOOxjgblNI-unsplash.313e08b3.jpg";